<div class="test-container">
  <h1 class="page-title">Table Component Test</h1>

  <h2 class="section-title">Roles Table</h2>
  <app-table
    [data]="rolesData"
    [columns]="rolesColumns"
    [config]="rolesConfig"
    [pagination]="rolesPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onSearchChange($event)"></app-table>

  <h2 class="section-title" style="margin-top: 2rem">Users Table</h2>
  <app-table
    [data]="usersData"
    [columns]="usersColumns"
    [config]="usersConfig"
    [pagination]="usersPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onSearchChange($event)"></app-table>
</div>
